import {
  format,
  formatDistanceStrict,
  parseISO,
  startOfWeek,
  endOfWeek,
  isValid,
  differenceInMinutes,
} from 'date-fns';

const UK_LOCALE = 'en-GB';

const toDate = (value) => {
  if (!value) return null;
  const dt = value instanceof Date ? value : parseISO(String(value));
  return isValid(dt) ? dt : null;
};

export const getPayrollWeekStartISO = (inputDate = new Date()) => {
  const weekStart = startOfWeek(inputDate, { weekStartsOn: 1 });
  return format(weekStart, 'yyyy-MM-dd');
};

export const normalizeToPayrollWeekStart = (dateLike) => {
  const parsed = toDate(dateLike);
  if (!parsed) return getPayrollWeekStartISO();
  return getPayrollWeekStartISO(parsed);
};

export const getPayrollWeekRangeLabel = (weekStartISO) => {
  const weekStart = toDate(weekStartISO);
  if (!weekStart) return '-';
  const weekEnd = endOfWeek(weekStart, { weekStartsOn: 1 });
  return `${format(weekStart, 'dd MMM yyyy')} - ${format(weekEnd, 'dd MMM yyyy')}`;
};

export const formatUKDate = (value) => {
  const dt = toDate(value);
  if (!dt) return '-';
  return new Intl.DateTimeFormat(UK_LOCALE, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'Europe/London',
  }).format(dt);
};

export const formatUKTime = (value) => {
  const dt = toDate(value);
  if (!dt) return '-';
  return new Intl.DateTimeFormat(UK_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Europe/London',
  }).format(dt);
};

export const formatUKDateTime = (value) => {
  const dt = toDate(value);
  if (!dt) return '-';
  return new Intl.DateTimeFormat(UK_LOCALE, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Europe/London',
  }).format(dt);
};

export const minutesToHoursMinutes = (minutes) => {
  const safe = Number.isFinite(Number(minutes)) ? Number(minutes) : 0;
  const hours = Math.floor(safe / 60);
  const mins = Math.round(safe % 60);
  return `${hours}h ${mins}m`;
};

export const renderPaidHours = (hours) => {
  const val = Number(hours);
  if (!Number.isFinite(val)) return '0.00h';
  return `${val.toFixed(2)}h`;
};

export const getElapsedLabel = (start, end = new Date()) => {
  const startDate = toDate(start);
  const endDate = toDate(end);
  if (!startDate || !endDate) return '-';
  if (endDate < startDate) return '0m';

  const mins = differenceInMinutes(endDate, startDate);
  return minutesToHoursMinutes(mins);
};

export const getElapsedPreciseLabel = (start, end = new Date()) => {
  const startDate = toDate(start);
  const endDate = toDate(end);
  if (!startDate || !endDate) return '-';
  if (endDate < startDate) return '0m';

  return formatDistanceStrict(startDate, endDate, { unit: 'minute' });
};

export const formatDateInputForDateTimeLocal = (value) => {
  const dt = toDate(value);
  if (!dt) return '';
  return format(dt, "yyyy-MM-dd'T'HH:mm");
};
